import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Categories API
export const categoriesApi = {
  getAll: () => api.get('/categories'),
  create: (data) => api.post('/categories', data),
  delete: (id) => api.delete(`/categories/${id}`),
};

// Products API
export const productsApi = {
  getAll: (category) => api.get('/products', { params: category ? { category } : {} }),
  getBySlug: (slug) => api.get(`/products/${slug}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

// Site Content API
export const siteContentApi = {
  get: () => api.get('/site-content'),
  update: (data) => api.put('/site-content', data),
};

// Orders API
export const ordersApi = {
  create: (data) => api.post('/orders', data),
  getAll: (limit = 50, skip = 0) => api.get(`/orders?limit=${limit}&skip=${skip}`),
  getById: (id) => api.get(`/orders/${id}`),
  updateStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
};

// Checkout API
export const checkoutApi = {
  createSession: (data) => api.post('/checkout/create-session', data),
};

// Analytics API
export const analyticsApi = {
  getSales: () => api.get('/analytics/sales'),
  getSummary: () => api.get('/analytics/summary'),
};

export default api;
